import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";
import {
  initialFilterStateProps,
  useProductFilterContext,
  useProductParamsContext,
} from "./context";

// 조회 parm
export const useSubmit = () => {
  const { setParam } = useProductParamsContext();
  const { filters } = useProductFilterContext();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as initialFilterStateProps;
    filters &&
      (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
        (key) => {
          const value = filters[key];
          if (!value) return;
          param = {
            ...param,
            [key]: filters[key],
          };
        }
      );
    setParam(param);
  };

  return { onSubmit };
};

// 상세모달 오픈
export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;

  const params = {
    no: props.data.rmPdNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};
